var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"d-flex bread"},_vm._l((_vm.items),function(item,i){return _c('li',{key:i,class:{ last: !item.href }},[(item.href)?_c('router-link',{attrs:{"to":item.href}},[_vm._v("\n      "+_vm._s(item.text)+"\n    ")]):[_vm._v("\n      "+_vm._s(item.text)+"\n    ")]],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }